









import Vue from "vue";

export default Vue.extend({
  name: "Interactive",
  props: {
    rect: { type: Object, default: () => ({}) },
  },
});
